import { Component, HostBinding, Input } from '@angular/core'

@Component({
    selector: 'mg-checkout-accordion-tab,[mg-checkout-accordion-tab]',
    templateUrl: './checkout-accordion-tab.component.html',
    styleUrls: ['./checkout-accordion-tab.component.scss'],
})
export class CheckoutAccordionTabComponent {
    @Input()
    @HostBinding('class._is_active')
    isActive: boolean = false

    @Input()
    @HostBinding('class._is_disabled')
    isDisabled: boolean = false

    @Input()
    @HostBinding('class.with-top-emphasis')
    withTopEmphasis: boolean = false

    @Input()
    title: string = ''

    @HostBinding('attr.data-step')
    @Input()
    step: string = ''

    private _titleCompleted

    get titleCompleted() {
        return this._titleCompleted || this.title
    }

    @Input()
    set titleCompleted(titleCompleted) {
        this._titleCompleted = titleCompleted
    }
}
